import {
  makeStyles,
  createStyles,
  Theme,
  Chip as MuiChip,
  ChipProps as MuiChipProps,
} from "@material-ui/core";

export const Chip = ({ label, ...props }: ChipProps) => {
  const classes = useStyles();
  return (
    <MuiChip
      label={label}
      size="small"
      color="primary"
      variant="outlined"
      classes={{ label: classes.label }}
      className={classes.chip}
      {...props}
    />
  );
};

export type ChipProps = MuiChipProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      width: "fit-content",
      fontSize: 12,
      lineHeight: 19,
      letterSpacing: 1,
      maxHeight: 24,
    },
    label: {
      lineHeight: "1!important",
    },
  }),
);
